import React from "react";
import { IconButton, SxProps, Theme } from "@mui/material";
import { MODALS } from "../../config/params";
import { ChatSupportIcon } from "../Icons";
import { defaultTheme } from "../../styles/muiTheme";
import { useModal } from "../../context/ModalContext";

type CustomerSupportButtonVariant = "round" | "square";

const variantStyles: Record<CustomerSupportButtonVariant, SxProps<Theme>> = {
  round: {
    "width": 40,
    "height": 40,
    "flexShrink": 0,
    "backgroundColor": "taupe.dark",
    "border": 1,
    "borderColor": "taupe.light",
    "&:hover": { backgroundColor: "neutral.main" },
  },
  square: {
    "width": "3rem",
    "height": "3rem",
    "borderRadius": "0.25rem",
    "backgroundColor": "#F4EFEB",
    "&:hover": { backgroundColor: "neutral.main" },
  },
};

interface ICustomerSupportButtonProps {
  variant: CustomerSupportButtonVariant;
  sx?: SxProps<Theme>;
  onClick?: () => void;
}

const CustomerSupportButton = ({ variant, sx, onClick }: ICustomerSupportButtonProps) => {
  const { openModal } = useModal();

  const handleClick = () => {
    onClick?.();
    openModal(MODALS.CUSTOMER_SUPPORT_MODAL);
  };

  return (
    <IconButton
      onClick={handleClick}
      sx={[variantStyles[variant], ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    >
      <ChatSupportIcon width={24} height={24} color={defaultTheme.palette.black.main} />
    </IconButton>
  );
};

export default CustomerSupportButton;
